export const intComma = (x: number): string => {
  if (x == null || isNaN(Number(x))) {
    return '';
  }
  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
